/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlWspdRule = {
    CloudInvocation: 'CLOUD__INVOCATION',
    CloudInvocationLowSeverity: 'CLOUD__INVOCATION__LOW_SEVERITY',
    CloudInvocationManagedDevice: 'CLOUD__INVOCATION__MANAGED_DEVICE',
    CloudInvocationKnownSafeIp: 'CLOUD__INVOCATION__KNOWN_SAFE_IP',
    CloudDiscovery: 'CLOUD__DISCOVERY',
    CloudDiscoveryLowSeverity: 'CLOUD__DISCOVERY__LOW_SEVERITY',
    CloudDiscoveryManagedDevice: 'CLOUD__DISCOVERY__MANAGED_DEVICE',
    CloudDiscoveryKnownSafeIp: 'CLOUD__DISCOVERY__KNOWN_SAFE_IP',
    CloudDataTransfer: 'CLOUD__DATA_TRANSFER',
    CloudDataTransferLowSeverity: 'CLOUD__DATA_TRANSFER__LOW_SEVERITY',
    CloudDataTransferManagedDevice: 'CLOUD__DATA_TRANSFER__MANAGED_DEVICE',
    CloudDataTransferKnownSafeIp: 'CLOUD__DATA_TRANSFER__KNOWN_SAFE_IP',
    CloudPersistence: 'CLOUD__PERSISTENCE',
    CloudPersistenceLowSeverity: 'CLOUD__PERSISTENCE__LOW_SEVERITY',
    CloudPersistenceManagedDevice: 'CLOUD__PERSISTENCE__MANAGED_DEVICE',
    CloudPersistenceKnownSafeIp: 'CLOUD__PERSISTENCE__KNOWN_SAFE_IP',
    EndpointDiscovery: 'ENDPOINT__DISCOVERY',
    EndpointDiscoveryLowSeverity: 'ENDPOINT__DISCOVERY__LOW_SEVERITY',
    EndpointDiscoveryUserTechnical: 'ENDPOINT__DISCOVERY__USER_TECHNICAL',
    EndpointLiveOffTheLandLowSeverity: 'ENDPOINT__LIVE_OFF_THE_LAND__LOW_SEVERITY',
    EndpointLiveOffTheLandBlockedHva: 'ENDPOINT__LIVE_OFF_THE_LAND__BLOCKED_HVA',
    EndpointLiveOffTheLandBlocked: 'ENDPOINT__LIVE_OFF_THE_LAND__BLOCKED',
    EndpointLiveOffTheLandMasqueraded: 'ENDPOINT__LIVE_OFF_THE_LAND__MASQUERADED',
    EndpointLiveOffTheLandAiVerdict: 'ENDPOINT__LIVE_OFF_THE_LAND__AI_VERDICT',
    EndpointLiveOffTheLandUserNonTechnical: 'ENDPOINT__LIVE_OFF_THE_LAND__USER_NON_TECHNICAL',
    EndpointLiveOffTheLand: 'ENDPOINT__LIVE_OFF_THE_LAND',
    EndpointNuisance: 'ENDPOINT__NUISANCE',
    EndpointExecutionLowSeverity: 'ENDPOINT__EXECUTION__LOW_SEVERITY',
    EndpointExecutionBlockedHva: 'ENDPOINT__EXECUTION__BLOCKED_HVA',
    EndpointExecutionMasqueraded: 'ENDPOINT__EXECUTION__MASQUERADED',
    EndpointExecutionBenign: 'ENDPOINT__EXECUTION__BENIGN',
    EndpointExecutionBlocked: 'ENDPOINT__EXECUTION__BLOCKED',
    EndpointExecution: 'ENDPOINT__EXECUTION',
    EndpointExecutionTechnicalUser: 'ENDPOINT__EXECUTION__TECHNICAL_USER',
    EndpointMalwareDiscovery: 'ENDPOINT__MALWARE_DISCOVERY',
    EndpointMalwareDiscoveryHva: 'ENDPOINT__MALWARE_DISCOVERY__HVA',
    EndpointMalwareDiscoveryBlocked: 'ENDPOINT__MALWARE_DISCOVERY__BLOCKED',
    EndpointMalwareDiscoveryBlockedHva: 'ENDPOINT__MALWARE_DISCOVERY__BLOCKED_HVA',
    EndpointMalwareDiscoveryBenign: 'ENDPOINT__MALWARE_DISCOVERY__BENIGN',
    EndpointMalwareDiscoveryServer: 'ENDPOINT__MALWARE_DISCOVERY__SERVER',
    EndpointMalwareDiscoveryNoFiles: 'ENDPOINT__MALWARE_DISCOVERY__NO_FILES',
    EndpointMalwareDiscoveryLateStageBlocked: 'ENDPOINT__MALWARE_DISCOVERY__LATE_STAGE_BLOCKED',
    EndpointMalwareDiscoveryLateStage: 'ENDPOINT__MALWARE_DISCOVERY__LATE_STAGE',
    EndpointMalwareExecution: 'ENDPOINT__MALWARE_EXECUTION',
    EndpointMalwareExecutionBlocked: 'ENDPOINT__MALWARE_EXECUTION__BLOCKED',
    EndpointMalwareExecutionBlockedHva: 'ENDPOINT__MALWARE_EXECUTION__BLOCKED_HVA',
    EndpointLateStage: 'ENDPOINT__LATE_STAGE',
    EndpointLateStageBlocked: 'ENDPOINT__LATE_STAGE__BLOCKED',
    EndpointLateStageBlockedHva: 'ENDPOINT__LATE_STAGE__BLOCKED_HVA',
    EndpointLateStageBlockedAdministrator: 'ENDPOINT__LATE_STAGE__BLOCKED_ADMINISTRATOR',
    EndpointLateStageAdministrator: 'ENDPOINT__LATE_STAGE__ADMINISTRATOR',
    EndpointRemoteManagement: 'ENDPOINT__REMOTE_MANAGEMENT',
    EndpointRemoteManagementBlocked: 'ENDPOINT__REMOTE_MANAGEMENT__BLOCKED',
    EndpointRemoteManagementBlockedHva: 'ENDPOINT__REMOTE_MANAGEMENT__BLOCKED_HVA',
    EndpointRemoteManagementAdminInstall: 'ENDPOINT__REMOTE_MANAGEMENT__ADMIN_INSTALL',
    EndpointRemoteManagementUserTechnical: 'ENDPOINT__REMOTE_MANAGEMENT__USER_TECHNICAL',
    EndpointLateralMovement: 'ENDPOINT__LATERAL_MOVEMENT',
    EndpointLateralMovementLowSeverity: 'ENDPOINT__LATERAL_MOVEMENT__LOW_SEVERITY',
    EndpointLateralMovementHva: 'ENDPOINT__LATERAL_MOVEMENT__HVA',
    EndpointLateralMovementServer: 'ENDPOINT__LATERAL_MOVEMENT__SERVER',
    EndpointLateralMovementBlocked: 'ENDPOINT__LATERAL_MOVEMENT__BLOCKED',
    EndpointLateralMovementTechnicalUser: 'ENDPOINT__LATERAL_MOVEMENT__TECHNICAL_USER',
    EndpointImpactLowSeverity: 'ENDPOINT__IMPACT__LOW_SEVERITY',
    EndpointImpact: 'ENDPOINT__IMPACT',
    EndpointEvasionLowSeverity: 'ENDPOINT__EVASION__LOW_SEVERITY',
    EndpointEvasion: 'ENDPOINT__EVASION',
    EndpointExploitationLowSeverity: 'ENDPOINT__EXPLOITATION__LOW_SEVERITY',
    EndpointExploitation: 'ENDPOINT__EXPLOITATION',
    EndpointSimulation: 'ENDPOINT__SIMULATION',
    EndpointPlannedChange: 'ENDPOINT__PLANNED_CHANGE',
    IdentityDiscovery: 'IDENTITY__DISCOVERY',
    IdentityDiscoveryLowSeverity: 'IDENTITY__DISCOVERY__LOW_SEVERITY',
    IdentityRejectedMfa: 'IDENTITY__REJECTED_MFA',
    IdentityRejectedMfaHuntAuthorizedDevice: 'IDENTITY__REJECTED_MFA__HUNT__AUTHORIZED_DEVICE',
    IdentityRejectedMfaHuntHighUsageIpAddress: 'IDENTITY__REJECTED_MFA__HUNT__HIGH_USAGE_IP_ADDRESS',
    IdentityLogin: 'IDENTITY__LOGIN',
    IdentityLoginLowSeverity: 'IDENTITY__LOGIN__LOW_SEVERITY',
    IdentityLoginNoUser: 'IDENTITY__LOGIN__NO_USER',
    IdentityLoginBlocked: 'IDENTITY__LOGIN__BLOCKED',
    IdentityLoginBlockedVip: 'IDENTITY__LOGIN__BLOCKED_VIP',
    IdentityLoginBlockedPrivacyPolicy: 'IDENTITY__LOGIN__BLOCKED_PRIVACY_POLICY',
    IdentityLoginManagedDevice: 'IDENTITY__LOGIN__MANAGED_DEVICE',
    IdentityLoginHuntManagedDevice: 'IDENTITY__LOGIN__HUNT__MANAGED_DEVICE',
    IdentityLoginAdversarialCountry: 'IDENTITY__LOGIN__ADVERSARIAL_COUNTRY',
    IdentityLoginHostingProvider: 'IDENTITY__LOGIN__HOSTING_PROVIDER',
    IdentityLoginKnownSafeIpAddress: 'IDENTITY__LOGIN__KNOWN_SAFE_IP_ADDRESS',
    IdentityLoginKnownUnsafeIpAddress: 'IDENTITY__LOGIN__KNOWN_UNSAFE_IP_ADDRESS',
    IdentityLoginTor: 'IDENTITY__LOGIN__TOR',
    IdentityLoginAitmProxy: 'IDENTITY__LOGIN__AITM_PROXY',
    IdentityLoginPrivacyVpnMobile: 'IDENTITY__LOGIN__PRIVACY_VPN__MOBILE',
    IdentityLoginPrivacyVpnExternal: 'IDENTITY__LOGIN__PRIVACY_VPN__EXTERNAL',
    IdentityLoginPrivacyVpn: 'IDENTITY__LOGIN__PRIVACY_VPN',
    IdentityLoginHuntHighUsageIpAddress: 'IDENTITY__LOGIN__HUNT__HIGH_USAGE_IP_ADDRESS',
    IdentityLoginHuntIspHighUsageRegion: 'IDENTITY__LOGIN__HUNT__ISP_HIGH_USAGE_REGION',
    IdentityLoginHuntApplePrivateRelay: 'IDENTITY__LOGIN__HUNT__APPLE_PRIVATE_RELAY',
    IdentityLoginHuntBlockedByPolicy: 'IDENTITY__LOGIN__HUNT__BLOCKED_BY_POLICY',
    IdentityLoginHuntAuthorizedDevice: 'IDENTITY__LOGIN__HUNT__AUTHORIZED_DEVICE',
    IdentityLoginHuntAitm: 'IDENTITY__LOGIN__HUNT__AITM',
    IdentityLoginHuntFailedLogin: 'IDENTITY__LOGIN__HUNT__FAILED_LOGIN',
    IdentityLoginMonitorMailboxRules: 'IDENTITY__LOGIN__MONITOR__MAILBOX_RULES',
    IdentityLoginMonitorMailboxSend: 'IDENTITY__LOGIN__MONITOR__MAILBOX_SEND',
    IdentityLoginMonitorMassEmailAccess: 'IDENTITY__LOGIN__MONITOR__MASS_EMAIL_ACCESS',
    IdentityLoginMonitorPersistence: 'IDENTITY__LOGIN__MONITOR__PERSISTENCE',
    IdentityLoginMonitorOauthGrant: 'IDENTITY__LOGIN__MONITOR__OAUTH_GRANT',
    IdentityLoginMonitorSessionChange: 'IDENTITY__LOGIN__MONITOR__SESSION_CHANGE',
    IdentityLoginMonitorAitm: 'IDENTITY__LOGIN__MONITOR__AITM',
    IdentityPersistence: 'IDENTITY__PERSISTENCE',
    IdentityPersistenceLowSeverity: 'IDENTITY__PERSISTENCE__LOW_SEVERITY',
    IdentityPersistenceTechnicalUser: 'IDENTITY__PERSISTENCE__TECHNICAL_USER',
    IdentityPersistenceAdminUser: 'IDENTITY__PERSISTENCE__ADMIN_USER',
    IdentityBruteForce: 'IDENTITY__BRUTE_FORCE',
    IdentityPublicCredentialExposure: 'IDENTITY__PUBLIC_CREDENTIAL_EXPOSURE',
    IdentityPublicCredentialExposurePasswordReset: 'IDENTITY__PUBLIC_CREDENTIAL_EXPOSURE__PASSWORD_RESET',
    IdentityPublicCredentialExposureOldBreach: 'IDENTITY__PUBLIC_CREDENTIAL_EXPOSURE__OLD_BREACH',
    IdentityPublicCredentialExposureImportantUser: 'IDENTITY__PUBLIC_CREDENTIAL_EXPOSURE__IMPORTANT_USER',
    IdentityPrivateCredentialExposureDcSync: 'IDENTITY__PRIVATE_CREDENTIAL_EXPOSURE__DC_SYNC',
    IdentityPrivateCredentialExposureLowSeverity: 'IDENTITY__PRIVATE_CREDENTIAL_EXPOSURE__LOW_SEVERITY',
    IdentityPrivateCredentialExposure: 'IDENTITY__PRIVATE_CREDENTIAL_EXPOSURE',
    IdentityAccountCompromise: 'IDENTITY__ACCOUNT_COMPROMISE',
    IdentitySimulation: 'IDENTITY__SIMULATION',
    EndpointPersistenceLowSeverity: 'ENDPOINT__PERSISTENCE__LOW_SEVERITY',
    EndpointPersistenceBlocked: 'ENDPOINT__PERSISTENCE__BLOCKED',
    EndpointPersistenceBlockedHva: 'ENDPOINT__PERSISTENCE__BLOCKED_HVA',
    EndpointPersistenceHva: 'ENDPOINT__PERSISTENCE__HVA',
    EndpointPersistenceUserTechnical: 'ENDPOINT__PERSISTENCE__USER_TECHNICAL',
    EndpointPersistence: 'ENDPOINT__PERSISTENCE',
    NetworkInboundConnection: 'NETWORK__INBOUND_CONNECTION',
    NetworkInboundConnectionKnownSafeIp: 'NETWORK__INBOUND_CONNECTION__KNOWN_SAFE_IP',
    NetworkInboundConnectionKnownUnsafeIp: 'NETWORK__INBOUND_CONNECTION__KNOWN_UNSAFE_IP',
    NetworkInboundConnectionBlocked: 'NETWORK__INBOUND_CONNECTION__BLOCKED',
    NetworkInboundConnectionTor: 'NETWORK__INBOUND_CONNECTION__TOR',
    NetworkInboundConnectionVpn: 'NETWORK__INBOUND_CONNECTION__VPN',
    NetworkInboundConnectionProxy: 'NETWORK__INBOUND_CONNECTION__PROXY',
    NetworkInboundConnectionRelay: 'NETWORK__INBOUND_CONNECTION__RELAY',
    NetworkInboundConnectionLowSeverity: 'NETWORK__INBOUND_CONNECTION__LOW_SEVERITY',
    NetworkOutboundConnection: 'NETWORK__OUTBOUND_CONNECTION',
    NetworkOutboundConnectionKnownSafeIp: 'NETWORK__OUTBOUND_CONNECTION__KNOWN_SAFE_IP',
    NetworkOutboundConnectionKnownUnsafeIp: 'NETWORK__OUTBOUND_CONNECTION__KNOWN_UNSAFE_IP',
    NetworkOutboundConnectionServer: 'NETWORK__OUTBOUND_CONNECTION__SERVER',
    NetworkOutboundConnectionTor: 'NETWORK__OUTBOUND_CONNECTION__TOR',
    NetworkOutboundConnectionTechnicalUser: 'NETWORK__OUTBOUND_CONNECTION__TECHNICAL_USER',
    NetworkOutboundConnectionVpn: 'NETWORK__OUTBOUND_CONNECTION__VPN',
    NetworkOutboundConnectionProxy: 'NETWORK__OUTBOUND_CONNECTION__PROXY',
    NetworkOutboundConnectionRelay: 'NETWORK__OUTBOUND_CONNECTION__RELAY',
    NetworkOutboundConnectionBlocked: 'NETWORK__OUTBOUND_CONNECTION__BLOCKED',
    NetworkOutboundConnectionBlockedHva: 'NETWORK__OUTBOUND_CONNECTION__BLOCKED_HVA',
    NetworkOutboundConnectionLowSeverity: 'NETWORK__OUTBOUND_CONNECTION__LOW_SEVERITY',
    NetworkPhishing: 'NETWORK__PHISHING',
    NetworkPhishingLowSeverity: 'NETWORK__PHISHING__LOW_SEVERITY',
    NetworkPhishingMobile: 'NETWORK__PHISHING__MOBILE',
    NetworkPhishingHuntBlocked: 'NETWORK__PHISHING__HUNT__BLOCKED',
    NetworkNoisy: 'NETWORK__NOISY',
    NetworkDiscovery: 'NETWORK__DISCOVERY',
    NetworkDiscoveryLowSeverity: 'NETWORK__DISCOVERY__LOW_SEVERITY',
    EmailPhishing: 'EMAIL__PHISHING',
    EmailPhishingVip: 'EMAIL__PHISHING__VIP',
    EmailPhishingBlocked: 'EMAIL__PHISHING__BLOCKED',
    EmailPhishingLowSeverity: 'EMAIL__PHISHING__LOW_SEVERITY',
    EmailPhishingReported: 'EMAIL__PHISHING_REPORTED',
    EmailEvasionLowSeverity: 'EMAIL__EVASION__LOW_SEVERITY',
    EmailEvasion: 'EMAIL__EVASION',
    EmailMalware: 'EMAIL__MALWARE',
    EmailMalwareBlocked: 'EMAIL__MALWARE__BLOCKED',
    EmailMalwareBenign: 'EMAIL__MALWARE__BENIGN',
    EmailMaliciousLink: 'EMAIL__MALICIOUS_LINK',
    EmailMaliciousLinkBlocked: 'EMAIL__MALICIOUS_LINK__BLOCKED',
    EmailGraymail: 'EMAIL__GRAYMAIL',
    EmailSpam: 'EMAIL__SPAM',
    EmailBusinessEmailCompromise: 'EMAIL__BUSINESS_EMAIL_COMPROMISE',
    DataDataTransferBlocked: 'DATA__DATA_TRANSFER__BLOCKED',
    DataDataTransfer: 'DATA__DATA_TRANSFER',
    DataDataShareBlocked: 'DATA__DATA_SHARE_BLOCKED',
    DataDataShare: 'DATA__DATA_SHARE',
    PosturePosture: 'POSTURE__POSTURE',
    PostureHealth: 'POSTURE__HEALTH',
    OtherDeception: 'OTHER__DECEPTION',
    OtherDeceptionLowSeverity: 'OTHER__DECEPTION__LOW_SEVERITY',
    OtherUnknown: 'OTHER__UNKNOWN',
    OtherDiagnostic: 'OTHER__DIAGNOSTIC',
    OtherInformationalEvent: 'OTHER__INFORMATIONAL_EVENT',
    OtherWarning: 'OTHER__WARNING',
    OtherWarningLowSeverity: 'OTHER__WARNING__LOW_SEVERITY',
    OtherCustomDetection: 'OTHER__CUSTOM_DETECTION',
    OtherCustomDetectionLowSeverity: 'OTHER__CUSTOM_DETECTION__LOW_SEVERITY'
} as const;
export type ControlWspdRule = typeof ControlWspdRule[keyof typeof ControlWspdRule];


export function ControlWspdRuleFromJSON(json: any): ControlWspdRule {
    return ControlWspdRuleFromJSONTyped(json, false);
}

export function ControlWspdRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlWspdRule {
    return json as ControlWspdRule;
}

export function ControlWspdRuleToJSON(value?: ControlWspdRule | null): any {
    return value as any;
}

